import React from 'react';
import { motion } from "framer-motion"
import '../App.css';

function OpenWindow(event, info) {
  // let mainWindow = document.querySelector(".Application");
  let myElement = document.querySelector("#panel-background");
  // let view = document.querySelector(".APIS");
  let filter = document.querySelector("#panel-background-filter");
  let clear = document.querySelector("#clear-panel");
  let daily = document.querySelector(".daily-background");
  // let footer = document.querySelector(".FooterFlex");
  // let apiRef = document.querySelector(".APIS");
  let search = document.querySelector(".Search");
  let icons = document.querySelector(".Icons");
  let subhead = document.querySelector(".Subhead");
  let divider = document.querySelector(".Divider");
  // let poll = document.querySelector(".Poll");
  let todayInfo = document.querySelector(".TodayInfo");
  let umbrellaText = document.querySelector("#umbrella-text");
  let sweaterText = document.querySelector("#sweater-text");
  let scarfText = document.querySelector("#scarf-text");
  // let umbrella = document.querySelector("#umbrella-icon");
  // let sweater = document.querySelector("#sweater-icon");
  // let scarf = document.querySelector("#scarf-icon");
  if (myElement.style.height === "40%") {
    // view.style.height = "50%"
    // mainWindow.style.height = "100%";
    myElement.style.height = "30%";
    myElement.style.width = "100%";
    myElement.style.left = "0%";
    myElement.style.top = "0%";
    myElement.style.borderRadius = "0px";
    myElement.style.scale = 2;
    myElement.style.boxShadow = "none";
    filter.style.borderRadius = "0px";
    clear.style.opacity = 0;
    clear.style.top = "80%";
    daily.style.opacity = 0;
    daily.style.top = "100%";
    search.style.opacity = 0;
    search.style.top = "100%";
    icons.style.opacity = 1;
    icons.style.scale = 1;
    subhead.style.opacity = 1;
    subhead.style.scale = 1;
    divider.style.scale = 1;
    divider.style.opacity = 1;
    // poll.style.opacity = 1;
    todayInfo.style.top = "35%";
    todayInfo.style.opacity = 1;
    // footer.style.top = "200%";
    // footer.style.opacity = 0;
    todayInfo.style.scale = 1;
    // if (umbrella.style.opacity === 1) {
    //   umbrellaText.style.opacity = 1;
    //   sweaterText.style.opacity = 0;
    //   scarfText.style.opacity = 0;
    // }
    // if (sweater.style.opacity === 1) {
    //   sweaterText.style.opacity = 1;
    //   umbrellaText.style.opacity = 0;
    //   scarfText.style.opacity = 0;
    // }
    // if (scarf.style.opacity === 1) {
    //   scarfText.style.opacity = 1;
    //   sweaterText.style.opacity = 0;
    //   umbrellaText.style.opacity = 0;
    // }
    
    // temp.style.fontSize = "10vh";
  } else {
    // view.style.height = "110%"
    // mainWindow.style.height = "80%";
    myElement.style.height = "40%";
    myElement.style.width = "90%";
    myElement.style.left = "5%";
    myElement.style.top = "12%";
    myElement.style.borderRadius = "20px";
    myElement.style.scale = 1;
    myElement.style.boxShadow = "0px 0px 20px rgba(0, 0, 0, 0.2)";
    filter.style.borderRadius = "20px";
    clear.style.opacity = 1
    clear.style.top = "54%";
    daily.style.opacity = 1;
    daily.style.top = "68%";
    search.style.opacity = 1;
    search.style.top = "92%";
    icons.style.opacity = 0;
    icons.style.scale = 0.25;
    subhead.style.opacity = 0;
    subhead.style.scale = 0.25;
    divider.style.scale = 0;
    divider.style.opacity = 0;
    // poll.style.opacity = 0;
    todayInfo.style.top = "0%";
    todayInfo.style.opacity = 0;
    todayInfo.style.scale = 0.25;
    umbrellaText.style.opacity = 0;
    sweaterText.style.opacity = 0;
    scarfText.style.opacity = 0;
    // footer.style.top = "108%";
    // footer.style.opacity = 1;
    // temp.style.fontSize = "5vh";
  }
}


export const CurrentWeather = (props) => {
  return (
    <div className="Panel">
      {/* <div id="panel-background-filter"></div> */}
      <motion.div id="panel-background"
      whileTap={{ scale: 0.95 }} onClick={OpenWindow}>
        <div className="weather">
          <p id="temp">{props.temperature}</p>
          <p id="description">{props.description}</p> 
        <div id="panel-background-filter"></div>
        </div>
        <motion.div className="Clouds1" animate={{ x: 400, opacity: [0, 1, 0] }}
        transition={{ duration: 30, ease: "linear", loop: "Infinity" }}></motion.div>
        <motion.div className="Clouds2" animate={{ x: 400, opacity: [0, 1, 0] }}
        transition={{ duration: 120, ease: "linear", loop: "Infinity" }}></motion.div>
        <motion.div className="Clouds3" animate={{ x: 400, opacity: [1, 1, 0] }}
        transition={{ duration: 120, ease: "linear", loop: "Infinity" }}></motion.div>
        <motion.div className="Clouds4" animate={{ x: 400, opacity: [0, 1, 0] }}
        transition={{ duration: 120, ease: "linear", loop: "Infinity" }}></motion.div>
        <motion.div className="Mist"></motion.div>
  <div className="umbrella-icon">
        <svg className="umbrella-icon-black" width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M16.4545 19c0 .7956-.2873 1.5587-.7988 2.1213-.5114.5626-1.2051.8787-1.9284.8787-.7233 0-1.417-.3161-1.9285-.8787C11.2873 20.5587 11 19.7956 11 19v-7m10 0c-.2375-2.73643-1.3936-5.27725-3.2427-7.12634C15.9082 3.02458 13.499 2 11 2 8.50103 2 6.09178 3.02458 4.2427 4.87366 2.39361 6.72275 1.23746 9.26357 1 12h20z" stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
<svg className="umbrella-icon-white" width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M16.4545 19c0 .7956-.2873 1.5587-.7988 2.1213-.5114.5626-1.2051.8787-1.9284.8787-.7233 0-1.417-.3161-1.9285-.8787C11.2873 20.5587 11 19.7956 11 19v-7m10 0c-.2375-2.73643-1.3936-5.27725-3.2427-7.12634C15.9082 3.02458 13.499 2 11 2 8.50103 2 6.09178 3.02458 4.2427 4.87366 2.39361 6.72275 1.23746 9.26357 1 12h20z" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
<div className="icon-text" id="umbrella-text">Umbrella for sure</div>
</div>
<div className="sweater-icon">
        <svg className="sweater-icon-black" width="35" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M14 2.0258l.9803.19767c.0553-.2746-.007-.55983-.1719-.78629s-.4172-.37337-.6955-.40499L14 2.0258zM2.70079 20.771l-.94574.3249c.13877.4039.51869.6751.94574.6751v-1zM14 2.02583l-.9803-.19768c-.0593.29395.0165.59899.2064.83105.19.23205.474.36663.7739.36663v-1zm8 0v1c.2999 0 .5839-.13457.7739-.36662.1899-.23205.2657-.53708.2064-.83103L22 2.02583zm0-.00003l-.124-.99229c-.276.0345-.5252.18241-.6877.4082-.1624.22579-.2235.50905-.1686.78174L22 2.0258zM33 20.771v1c.428 0 .8085-.2724.9465-.6775L33 20.771zm-4.2 0l-.9806.1961c.0935.4674.5039.8039.9806.8039v-1zm-.3773-1.9978l.9836-.1804-.9836.1804zM23.5859 7.88343l.5469-.83722c-.3224-.21057-.737-.21735-1.0661-.01742-.3291.19992-.5141.57103-.4758.95417l.995-.09953zm1.0842 10.83867l.995-.0995-.995.0995zm-13.3402 0l.9951.0995-.9951-.0995zm1.0868-10.86409l.995.09953c.038-.37995-.1437-.74838-.4683-.94953-.3245-.20115-.7353-.19991-1.0587.0032l.532.8468zM7.37095 18.8634l-.98252-.1861.98252.1861zm-.37096 1.9076v1c.47496 0 .88439-.3341.97967-.7994l-.97967-.2006zM14.1129 1.03219c-1.6468-.187079-3.4825.31945-5.20238 1.26879-1.73352.95685-3.42591 2.40376-4.80634 4.21858C1.33547 10.1595-.220525 15.3461 1.75505 21.0959l1.89147-.6499c-1.72521-5.0211-.3816-9.5195 2.04949-12.71563C6.91548 6.12717 8.39804 4.86829 9.877 4.05196c1.4925-.82384 2.9069-1.15788 4.0101-1.03255l.2258-1.98722zm.8674 1.19131v-.00003l-1.9606-.39535v.00003l1.9606.39535zM22 1.02583h-8v2h8v-2zm-.9803 1.19762l.0001.00003 1.9605-.3953v-.00003l-1.9606.3953zM33.9465 21.0935c1.8797-5.516.2539-10.6962-2.4537-14.3739-1.3536-1.83856-2.9967-3.33114-4.6571-4.32976-1.6381-.98525-3.3996-1.551277-4.9597-1.35633l.248 1.98457c.9399-.11746 2.2409.2196 3.6809 1.08565 1.4177.85269 2.8684 2.15966 4.0773 3.80163 2.4173 3.28334 3.7916 7.78814 2.1712 12.54304l1.8931.6451zM28.8 21.771H33v-2h-4.2v2zm-1.3609-2.8174c.1233.6722.2474 1.3494.3803 2.0135l1.9612-.3923c-.1292-.6457-.2505-1.3069-.3743-1.982l-1.9672.3608zm-4.4-10.23295c1.3628.89016 2.2723 2.31445 2.9408 4.13045.6721 1.8259 1.0613 3.9326 1.4592 6.1025l1.9672-.3608c-.3908-2.1311-.807-4.4156-1.5495-6.4326-.7462-2.0268-1.8607-3.89689-3.724-5.11399l-1.0937 1.67444zm2.626 9.90195L24.581 7.7839l-1.9901.19906L23.675 18.8216l1.9901-.199zm-3.9801 4.3981c2.3665 0 4.2156-2.0434 3.9801-4.3981l-1.9901.199c.1178 1.1774-.8068 2.1991-1.99 2.1991v2zm-7.37 0h7.37v-2h-7.37v2zm-3.9801-4.3981c-.2355 2.3547 1.6136 4.3981 3.9801 4.3981v-2c-1.1832 0-2.1078-1.0217-1.99-2.1991l-1.9901-.199zm1.0867-10.86413L10.3349 18.6226l1.9901.199 1.0867-10.86406-1.9901-.19907zM8.35348 19.0496c.41536-2.1926.82226-4.3252 1.5236-6.1718.69692-1.835 1.64542-3.27722 3.07152-4.173l-1.0639-1.69359c-1.93468 1.2153-3.09738 3.10289-3.87731 5.15649-.7755 2.0418-1.21106 4.3564-1.61896 6.5096l1.96505.3723zm-.37382 1.922c.12987-.6342.25223-1.2802.37382-1.922l-1.96505-.3723c-.12209.6445-.24171 1.2758-.36811 1.8931l1.95934.4012zm-5.27887.7994h4.2992v-2h-4.2992v2z" fill="#000"/>
  <path d="M14 2c1.3333 2.26387 4.8 5.43329 8 0" stroke="#000" stroke-width="2"/>
</svg>
<svg className="sweater-icon-white" width="35" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M14 2.0258l.9803.19767c.0553-.2746-.007-.55983-.1719-.78629s-.4172-.37337-.6955-.40499L14 2.0258zM2.70079 20.771l-.94574.3249c.13877.4039.51869.6751.94574.6751v-1zM14 2.02583l-.9803-.19768c-.0593.29395.0165.59899.2064.83105.19.23205.474.36663.7739.36663v-1zm8 0v1c.2999 0 .5839-.13457.7739-.36662.1899-.23205.2657-.53708.2064-.83103L22 2.02583zm0-.00003l-.124-.99229c-.276.0345-.5252.18241-.6877.4082-.1624.22579-.2235.50905-.1686.78174L22 2.0258zM33 20.771v1c.428 0 .8085-.2724.9465-.6775L33 20.771zm-4.2 0l-.9806.1961c.0935.4674.5039.8039.9806.8039v-1zm-.3773-1.9978l.9836-.1804-.9836.1804zM23.5859 7.88343l.5469-.83722c-.3224-.21057-.737-.21735-1.0661-.01742-.3291.19992-.5141.57103-.4758.95417l.995-.09953zm1.0842 10.83867l.995-.0995-.995.0995zm-13.3402 0l.9951.0995-.9951-.0995zm1.0868-10.86409l.995.09953c.038-.37995-.1437-.74838-.4683-.94953-.3245-.20115-.7353-.19991-1.0587.0032l.532.8468zM7.37095 18.8634l-.98252-.1861.98252.1861zm-.37096 1.9076v1c.47496 0 .88439-.3341.97967-.7994l-.97967-.2006zM14.1129 1.03219c-1.6468-.187079-3.4825.31945-5.20238 1.26879-1.73352.95685-3.42591 2.40376-4.80634 4.21858C1.33547 10.1595-.220525 15.3461 1.75505 21.0959l1.89147-.6499c-1.72521-5.0211-.3816-9.5195 2.04949-12.71563C6.91548 6.12717 8.39804 4.86829 9.877 4.05196c1.4925-.82384 2.9069-1.15788 4.0101-1.03255l.2258-1.98722zm.8674 1.19131v-.00003l-1.9606-.39535v.00003l1.9606.39535zM22 1.02583h-8v2h8v-2zm-.9803 1.19762l.0001.00003 1.9605-.3953v-.00003l-1.9606.3953zM33.9465 21.0935c1.8797-5.516.2539-10.6962-2.4537-14.3739-1.3536-1.83856-2.9967-3.33114-4.6571-4.32976-1.6381-.98525-3.3996-1.551277-4.9597-1.35633l.248 1.98457c.9399-.11746 2.2409.2196 3.6809 1.08565 1.4177.85269 2.8684 2.15966 4.0773 3.80163 2.4173 3.28334 3.7916 7.78814 2.1712 12.54304l1.8931.6451zM28.8 21.771H33v-2h-4.2v2zm-1.3609-2.8174c.1233.6722.2474 1.3494.3803 2.0135l1.9612-.3923c-.1292-.6457-.2505-1.3069-.3743-1.982l-1.9672.3608zm-4.4-10.23295c1.3628.89016 2.2723 2.31445 2.9408 4.13045.6721 1.8259 1.0613 3.9326 1.4592 6.1025l1.9672-.3608c-.3908-2.1311-.807-4.4156-1.5495-6.4326-.7462-2.0268-1.8607-3.89689-3.724-5.11399l-1.0937 1.67444zm2.626 9.90195L24.581 7.7839l-1.9901.19906L23.675 18.8216l1.9901-.199zm-3.9801 4.3981c2.3665 0 4.2156-2.0434 3.9801-4.3981l-1.9901.199c.1178 1.1774-.8068 2.1991-1.99 2.1991v2zm-7.37 0h7.37v-2h-7.37v2zm-3.9801-4.3981c-.2355 2.3547 1.6136 4.3981 3.9801 4.3981v-2c-1.1832 0-2.1078-1.0217-1.99-2.1991l-1.9901-.199zm1.0867-10.86413L10.3349 18.6226l1.9901.199 1.0867-10.86406-1.9901-.19907zM8.35348 19.0496c.41536-2.1926.82226-4.3252 1.5236-6.1718.69692-1.835 1.64542-3.27722 3.07152-4.173l-1.0639-1.69359c-1.93468 1.2153-3.09738 3.10289-3.87731 5.15649-.7755 2.0418-1.21106 4.3564-1.61896 6.5096l1.96505.3723zm-.37382 1.922c.12987-.6342.25223-1.2802.37382-1.922l-1.96505-.3723c-.12209.6445-.24171 1.2758-.36811 1.8931l1.95934.4012zm-5.27887.7994h4.2992v-2h-4.2992v2z" fill="#000"/>
  <path d="M14 2c1.3333 2.26387 4.8 5.43329 8 0" stroke="#fff" stroke-width="2"/>
</svg>
<div className="icon-text" id="sweater-text">Sweater Weather</div>
</div>
<div className="scarf-icon">
        <svg className="scarf-icon-black" width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M19 4v18h-8V4zM11 6H2v8h9M19 14h3V6h-3"/>
  <path d="M11 18.5h8" stroke="#000" stroke-width="2"/>
</svg>
<svg className="scarf-icon-white" width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path stroke="#FFFFFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M19 4v18h-8V4zM11 6H2v8h9M19 14h3V6h-3"/>
  <path d="M11 18.5h8" stroke="#FFFFFF" stroke-width="2"/>
</svg>
<div className="icon-text" id="scarf-text">Brrr...cover up</div>
</div>
    </motion.div>
    </div>
  );
}

export default CurrentWeather